import { HttpClient } from './httpClient';
import { API_CONFIG } from '../config/apiConfig';
import { HttpAnonymousClient } from './httpAnonymousClient';

export class ApiService {
  private static instance: HttpClient | null = null;

  static initialize(tokenProvider: () => Promise<string | null>) {
    if (!this.instance) {
      this.instance = new HttpClient(
        API_CONFIG.BASE_URL!,
        tokenProvider,
        API_CONFIG.DEFAULT_HEADERS
      );
    }
  }

  static get client(): HttpClient {
    if (!this.instance) {
      throw new Error('ApiService not initialized. Call ApiService.initialize() first.');
    }
    return this.instance;
  }

  static reset() {
    this.instance = null;
  }
}

// NO BEARER
export class ApiAnonymousService {
  private static instance: HttpAnonymousClient | null = null;

  static initialize() {
    if (!this.instance) {
      this.instance = new HttpAnonymousClient(
        API_CONFIG.BASE_URL!,
        API_CONFIG.DEFAULT_HEADERS
      );
    }
  }

  static get client(): HttpAnonymousClient {
    if (!this.instance) {
      throw new Error('ApiService not initialized. Call ApiService.initialize() first.');
    }
    return this.instance;
  }

  static reset() {
    this.instance = null;
  }
}